<template>
    <DModal
        ref="assignCustomerModal"
        :show="showModal"
        :title="__('orders.title.assign_customer_and_accept')"
        is-big
        is-confirm
        overflow-auto
        :is-awaiting-validation="true"
        @confirm="checkCustomerAssignment"
        @close="closeModal"
    >
        <DCard padding>
            <div>
                <p><strong>{{ __('orders.confirm_assignment') }}</strong></p>
                <div class="d-flex align-items-center align-middle">
                    <div class="col-2">
                        {{ __('orders.found_customers') }}
                    </div>
                    <div class="col-6">
                        <DSelect
                            class="select-margin"
                            :options="databaseCustomerOptions"
                            value="0"
                            @update:value="setSelectedDatabaseCustomer($event)"
                        />
                    </div>
                </div>
            </div>
        </DCard>
    </DModal>
</template>

<script setup>

import { computed, ref } from 'vue'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    selectedItem: {
        type: Object,
        default: () => { return {} }
    },
    databaseCustomers: {
        type: Array,
        default: () => { return [] }
    }
})
const emit = defineEmits(['confirm-modal', 'close-modal'])

const selectedDatabaseCustomerData = ref(props.databaseCustomers[0].id)
const assignCustomerModal = ref(null)

const databaseCustomerOptions = computed(() => {
    const customerOptions = [
        {
            label: __('orders.woo_commerce.create_new_customer'),
            value: null
        }
    ]

    for (const [index, customer] of Object.entries(props.databaseCustomers)) {
        const customerName = customer.company ? customer.company : `${customer.firstname} ${customer.lastname}`

        customerOptions.push({
            label: `${customerName} (${customer.id})`,
            value: Number(index)
        })
    }

    return customerOptions
})
function setSelectedDatabaseCustomer (event) {
    if (event === '') {
        selectedDatabaseCustomerData.value = null

        return
    }

    selectedDatabaseCustomerData.value = props.databaseCustomers[event].id
}
function checkCustomerAssignment () {
    emit('confirm-modal', selectedDatabaseCustomerData.value)
}

function closeModal () {
    emit('close-modal')
}
</script>

<style scoped>

</style>
